export const getIngredients = async () => {
  return await window.axios
    .get('/ingredients', {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      }
    });
};
